import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import { PageLoading } from "@/components/shared/loading";

const InvoiceGateNewPage = lazy(() => import("@/features/invoice-gate/pages/invoice-gate-new"));

export const Route = createFileRoute("/(app)/dashboard/invoice-gate/new")({
  component: () => (
    <Suspense fallback={<PageLoading />}>
      <InvoiceGateNewPage />
    </Suspense>
  ),
});
